import { post } from "storefront/GrailedAPI/request";

export type Params = {
  countryCode: number;
  phoneNumber: number;
};

/**
 * @name GrailedAPI.v1.Users.Verification.sendVerificationCode
 * @param {Params} params
 * @return {Promise<void>} sends the SMS code; rejects on failure
 */
const sendVerificationCode: (arg0: Params) => Promise<void> = (params) =>
  post("/api/users/send_verification_sms", params);

export default sendVerificationCode;
